import { gql } from '@apollo/client';

export const GET_APPLIED_JOBS = gql`
  query GetAppliedJobs(
    $first: Int
    $locale: Locale!
    $timezone: Timezone!
    $zone: Zone!
    $sortBy: AppliedJobSortByInput
  ) {
    viewer {
      id
      appliedJobs(first: $first, locale: $locale, sortBy: $sortBy) {
        edges {
          node {
            # this is candidate id
            id
            hasAppliedWithResume
            hasAppliedWithCoverLetter
            isExternal
            isActive
            notes
            events {
              status
              timestamp {
                dateTimeUtc
                shortAbsoluteLabel(timezone: $timezone, locale: $locale)
              }
            }
            appliedAt {
              dateTimeUtc
              shortAbsoluteLabel(timezone: $timezone, locale: $locale)
            }
            job {
              # this is job id
              id
              title
              location {
                label(locale: $locale, type: SHORT)
              }
              abstract
              createdAt {
                dateTimeUtc
                label(
                  context: JOB_POSTED
                  length: SHORT
                  timezone: $timezone
                  locale: $locale
                )
              }
              advertiser {
                id
                name(locale: $locale)
              }
              salary {
                label
                currencyLabel(zone: $zone)
              }
              products {
                branding {
                  logo {
                    url
                  }
                }
              }
              tracking {
                hasRoleRequirements
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_SAVED_JOBS = gql`
  query GetSavedJobs(
    $first: Int
    $locale: Locale!
    $timezone: Timezone!
    $zone: Zone!
  ) {
    viewer {
      id
      savedJobs(first: $first) {
        edges {
          node {
            id
            isActive
            notes
            isExternal
            createdAt {
              dateTimeUtc
              shortAbsoluteLabel(timezone: $timezone, locale: $locale)
            }
            job {
              id
              title
              location {
                label(locale: $locale, type: SHORT)
              }
              abstract
              createdAt {
                dateTimeUtc
                label(
                  context: JOB_POSTED
                  length: SHORT
                  timezone: $timezone
                  locale: $locale
                )
              }
              advertiser {
                id
                name(locale: $locale)
              }
              salary {
                label
                currencyLabel(zone: $zone)
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_APPLIED_JOB_DETAIL = gql`
  query GetAppliedJobDetail($jobId: ID!, $locale: Locale!) {
    viewer {
      id
      appliedJob(jobId: $jobId) {
        id
        documents {
          resume {
            attachmentMetadata {
              fileName
            }
          }
          coverLetter {
            attachmentMetadata {
              fileName
            }
          }
        }
      }
    }
    jobDetails(id: $jobId) {
      insights {
        ... on ApplicantCount {
          __typename
          count
          message(locale: $locale)
        }
        ... on ApplicantsWithResumePercentage {
          __typename
          percentage
          message(locale: $locale)
        }
        ... on ApplicantsWithCoverLetterPercentage {
          __typename
          percentage
          message(locale: $locale)
        }
      }
    }
  }
`;

export const GET_RESUME_LINK = gql`
  query GetResumeLink($jobId: ID!) {
    viewer {
      id
      appliedJob(jobId: $jobId) {
        id
        documents {
          resume {
            downloadLink
          }
        }
      }
    }
  }
`;

export const GET_COVER_LETTER_LINK = gql`
  query GetCoverLetterLink($jobId: ID!) {
    viewer {
      id
      appliedJob(jobId: $jobId) {
        id
        documents {
          coverLetter {
            downloadLink
          }
        }
      }
    }
  }
`;

export const GET_SIMILAR_COMMON_JOBS = gql(`
  query GetSimilarCommonJobs(
    $jobId: ID!
    $source: AttributionSource!
    $zone: Zone!
    $visitorId: UUID!
    $platform: Platform!
    $limit: Int!
    $locale: Locale!
    $timezone: Timezone!
    $languageCode: LanguageCodeIso!
    $cluster: SmarterSearchCluster
  ) {
    viewer {
      _id

      recommendations {
        similarJobsGlobal(
          jobId: $jobId
          source: $source
          zone: $zone
          visitorId: $visitorId
          platform: $platform
          limit: $limit
          cluster: $cluster
        ) {
          globalJobs {
            job {
              id
              advertiser {
                name
              }
              location {
                label(locale: $locale, type: SHORT)
              }
              createdAt {
                label(
                  context: JOB_POSTED
                  length: SHORT
                  timezone: $timezone
                  locale: $locale
                )
              }
              salary {
                currencyLabel(zone: $zone)
                label
              }
              title
              abstract
              classifications {
                label(languageCode: $languageCode)
              }
              products {
                branding {
                  logo {
                    url
                  }
                }
                bullets
              }
            }
            solMetadata
          }
          solMetadata
        }
      }
    }
  }
`);
